export const FETCH_BUILDINGS = 'a';
export const FETCH_PROBLEMS = 'b';
export const FETCH_SESSION = 'o';
export const SET_PROBLEMS = 'c';
export const SET_BUILDINGS = 'd';
export const SET_MAP = 'e';
export const SET_MARKERS = 'f';
export const FETCH_CURRENT_BUILDING = 'g';
export const SET_CURRENT_BUILDING = 'i';
export const SET_IS_MOBILE = 'n';

/* layers logic */
export const DISCARD_FILTERS = 'k';
export const FILTER_BY_PROBLEM = 'l';
export const SHOW_PROBLEM_LAYERS_BY_IDS = 'm';
export const SET_SESSION_USER = 'p';
